import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-041c0ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-block-filter" }
const _hoisted_2 = { class: "layout-block-filter_cont" }
const _hoisted_3 = { class: "layout-block-filter_filter" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.setCategories({id: category.id, categoryNew: category.category})),
            class: _normalizeClass({"layout-block-filter_item": true, active: category.active}),
            key: category.id
          }, [
            _createElementVNode("p", null, _toDisplayString(_ctx.getCorrectUppercaseCategory(category.category)), 1)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}